import { ComboBox } from '@reveni-io/reveni-ui'

import { getHours } from './helpers'

const TimeRangeSelector = ({ value, onChange, label }) => {
  return (
    <ComboBox
      label={label}
      fullWidth
      menuItems={getHours()}
      value={value}
      handleChange={e => onChange(e.target.value)}
    />
  )
}

export default TimeRangeSelector
